import React, { useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";

function ContactDetailsInformation({ onEditClick = () => {}, isShowEditIcon = false }) {
  const [t] = useTranslation();
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);
  const userDetails = useSelector((state) => state.userDetails || {});
  const contacts = userDetails?.extraInformation?.contactDetails || {};

  return (
    <div
      id="contactDetailsSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex flex-col items-start gap-3 self-stretch">
        <div className="flex justify-between items-center self-stretch">
          <span className="text-[#1D1B22] text-center font-semibold text-[24px] leading-[36px] font-['General_Sans']">
            {t("contactDetailsTitle")}
          </span>
          {isShowEditIcon && (
            <EditIcon
              className={`cursor-pointer ${isEditShowEditOnHover ? "visible" : "invisible"}`}
              onClick={onEditClick}
            />
          )}
        </div>
      </div>

      <div className="flex items-start content-start gap-x-6 gap-y-[30px] self-stretch flex-wrap">
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent title={t("permanentAddress")} subTitle={`${contacts?.permanentAddress ?? "-"}`} />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent title={t("currentResidenceAddress")} subTitle={`${contacts?.currentResidenceAddress ?? "-"}`} />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent title={t("country")} subTitle={`${contacts?.country ?? "-"}`} />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent title={t("phoneNumber")} subTitle={`${contacts?.phoneNumber ?? "-"}`} />
        </div>
        <div className="flex w-[330px] flex-col items-start gap-[2px]">
          <LabelComponent title={t("homeTelephone")} subTitle={`${contacts?.homeTelephone ?? "-"}`} />
        </div>
      </div>
    </div>
  );
}

ContactDetailsInformation.propTypes = {
  onEditClick: PropTypes.func,
  isShowEditIcon: PropTypes.bool,
};

export default ContactDetailsInformation;

